// Central site configuration — ALL business details are editable placeholders.
// Replace the marked values before launch. See /SETUP-INSTRUCTIONS.md.

export const SITE = {
  name: "Upgrade Law",
  tagline: "Strategic Legal Solutions for Businesses and Individuals.",
  // PLACEHOLDER — replace with the live domain before launch:
  url: "https://upgradelaw.in",

  // Phone & offices supplied by the practice. Email + live domain remain placeholders.
  email: "hello@upgradelaw.in", // PLACEHOLDER — replace with your real email
  phoneDisplay: "+91 80157 82116",
  phoneTel: "+918015782116",
  whatsapp: "918015782116",
  whatsappMessage:
    "Hello Upgrade Law, I would like to submit a legal enquiry. My matter relates to:",
  offices: [
    {
      label: "Hosur Office",
      lines: ["No. 95/1, Taluk Office Road,", "Hosur, Krishnagiri District,", "Tamil Nadu – 635109"],
      query: "No. 95/1 Taluk Office Road, Hosur, Krishnagiri District, Tamil Nadu 635109",
    },
    {
      label: "Bengaluru Office",
      lines: ["Flat 303, Alpine Square,", "Doddanagamangala, Electronic City Phase 2,", "Bengaluru – 560100"],
      query: "Alpine Square, Doddanagamangala, Electronic City Phase 2, Bengaluru 560100",
    },
  ],
  mapEmbed: (q) =>
    `https://www.google.com/maps?q=${encodeURIComponent(q)}&output=embed`,
  directions: (q) =>
    `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}`,
  placeholderNotice:
    "The email address is an editable placeholder — replace it before launch. Phone numbers and office addresses are as supplied by the practice.",

  serviceCategories: [
    "Corporate & Commercial Law",
    "Intellectual Property & Trademark",
    "Contract Drafting & Management",
    "Real Estate & Property Law",
    "Regulatory & Legal Compliance",
    "Litigation & Dispute Resolution",
    "Other / Not sure yet",
  ],
};

export const whatsappLink = (msg) =>
  `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(
    msg || SITE.whatsappMessage
  )}`;

export const telLink = `tel:${SITE.phoneTel}`;
export const mailLink = `mailto:${SITE.email}`;

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1617761141732-d481912af1a9?crop=entropy&cs=srgb&fm=jpg&q=80",
  boardroom:
    "https://images.unsplash.com/photo-1598139384902-5a8217874645?crop=entropy&cs=srgb&fm=jpg&q=80",
  contract:
    "https://images.unsplash.com/photo-1758518731462-d091b0b4ed0d?crop=entropy&cs=srgb&fm=jpg&q=80",
  handshake:
    "https://images.unsplash.com/photo-1521791136064-7986c2920216?crop=entropy&cs=srgb&fm=jpg&q=80",
  discussion:
    "https://images.unsplash.com/photo-1686771416282-3888ddaf249b?crop=entropy&cs=srgb&fm=jpg&q=80",
  highrise:
    "https://images.unsplash.com/photo-1443527394413-4b820fd08dde?crop=entropy&cs=srgb&fm=jpg&q=80",
};
